export interface SessionState {
  /**
   * The API session id.
   */
  id: string;
  /**
   * If we're currently authorizing
   */
  authorizing: boolean;
  /**
   * Session loaded
   */
  loaded: boolean;
  /**
   * Session type
   */
  type: string;
}

export const initialState: SessionState = {
  id: '',
  authorizing: false,
  loaded: false,
  type: '',
};
